<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Lista:"
    id="selectLista"
    placeholder="Selecione a Lista"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import SegmentationRepository from '@/shared/http/repositories/configurations/campaignlist.js'

export default {
  name: 'NxSelectCampanhaLista',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadListas()
  },
  methods: {
    onLoadListas () {
      SegmentationRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Listas', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectCampanhaLista.vue